import hotToast from "react-hot-toast";

const dismissibleMessage = (t, message) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <p style={{ marginRight: "5px", marginBottom: 0 }}>{message}</p>
      <span
        style={{ cursor: "pointer", lineHeight: "29px", marginRight: "-12px" }}
        className="Appkit4-icon icon-close-fill ap-font-12 ap-container-12"
        onClick={() => hotToast.dismiss(t.id)}
      />
    </div>
  );
};

const toast = (message, ...args) =>
  hotToast((t) => dismissibleMessage(t, message), ...args);

toast.error = (message, ...args) =>
  hotToast.error((t) => dismissibleMessage(t, message), ...args);

toast.success = (message, ...args) =>
  hotToast.success((t) => dismissibleMessage(t, message), ...args);

toast.notification = (message, args) =>
  hotToast((t) => dismissibleMessage(t, message), { icon: "🔔", ...args });

toast.promise = (promise, messages, opts) =>
  hotToast.promise(
    promise,
    {
      ...messages,
      success: (t) =>
        dismissibleMessage(
          t,
          typeof messages.success === "function"
            ? messages?.success(t)
            : (messages?.success ?? ""),
        ),
      error: (t) =>
        dismissibleMessage(
          t,
          typeof messages.error === "function"
            ? messages?.error(t)
            : (messages?.error ?? ""),
        ),
    },
    opts,
  );

toast.save = (promise, onSuccess, onError, messages, customDuration) => {
  if (!onError) {
    onError = onSuccess;
  }
  const duration = { duration: customDuration ?? 1000 };
  return hotToast.promise(
    promise,
    {
      loading: messages?.loading ?? "Saving Progress...",
      success: (result) => {
        onSuccess(result);
        return messages?.success ?? "Progress Saved";
      },
      error: (err) => {
        onError(err);
        return messages?.error ?? "Error Saving Progress";
      },
    },
    {
      success: duration,
      error: duration,
    },
  );
};

export default toast;
